/* eslint-disable lines-between-class-members */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from './notifications.service';
import { Notification } from './notification.model';
import { AuthenticationService } from '../sharedServices/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../core/services/storage/storage.service';
import UserDataService from '../sharedServices/user-data.service';
import { UserProfileDataService } from '../user-profile/user-profile-data.service';
import { FriendsService } from '../friends/services/friends.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css'],
})
export default class NotificationsComponent implements OnInit, OnDestroy {
  currentUser;
  language:string = localStorage.getItem("language")
  notifications: Notification[] = [
    // {
    //   category: "Wine added",
    //   cellar_bk_id: "c21b8490-aec5-4244-b8db-4ac46402338a",
    //   id: "663a36d80a7dea959a58207fb0257ede",
    //   invoker_user_id: "0618dc42-9065-4b76-976e-232ff77ea02d",
    //   label: "Akshay Prabhudesai has added new Wine: Drapier, Musigny Grand Cru",
    //   user_wine_id: "83345e96-4a33-4331-9b5e-8f5ef5f656c0",
    // }
  ];
  notificationSub;
  showNotifications = false;
  currentTime: number;

  constructor(
    private notificationService: NotificationsService,
    private router: Router,
    private authenticationService: AuthenticationService,
    public translate: TranslateService,
    private storageService: StorageService,
    private userDataService: UserDataService,
    private userProfileDataService: UserProfileDataService,
    private friendsService: FriendsService,
  ) {
    this.authenticationService.currentUser.subscribe((user) => this.currentUser = user);
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe((data) => {
      this.language = data.lang;
      this.notificationService.getUnreadNotifications().subscribe((notifications) => {
        this.displayNotification(notifications.data);
      });
    });
    this.notificationService.getUnreadNotifications().subscribe((notifications) => {
      this.displayNotification(notifications.data);
    });

    this.notificationSub = this.notificationService.connect(this.currentUser.username);
    this.notificationService.pushLiveNotification$.subscribe((data: any) => {
      if (data) {
        const response = data.data.onCreateNotification;
        this.processNotification(response);
        this.notifications = this.notifications.sort((a, b) => a.duration - b.duration);
      }
    });
    // this.notificationSub = this.notificationService.getNotifications(this.currentUser.username)
    //   .subscribe({
    //     next: (data) => {
    //       const response = data.data.notification;
    //     this.processNotification(response);
    //     this.notifications = this.notifications.sort((a, b) => a.duration - b.duration);
    //     },
    //     error: (error) => {
    //       console.warn(error);
    //     },
    //   }); 
  }

  displayNotification(data:any){
    const response = data.getNotificationPaginated.notifications;
    if(response){
      this.processOfflineNotifications(response)
      this.notifications = this.notifications.sort((a, b) => a.duration - b.duration);
    }
  }

  processNotification(response): void {
    if (response.invoker_user_id !== this.currentUser.username) {
      let levelNotifications = [];
      let vcEarnNotifications = [];
      let notificationsPopUp = [];
      let notificationMsg = '';
      const payload = response.payload[0];
      let invokerName = `${response.invoker_firstname} ${response.invoker_lastname}`;
      if (response.invoker_userType == "Business User") {
        invokerName = `${response.invoker_companyName}`;
      }
      switch (response.category) {
        case 'Kellerbook created':
          notificationMsg = `${invokerName} `+ this.translate.instant("has added new Kellerbook") +`: ${payload.cellar_bk_nm}`;
          break;
        case 'Kellerbook updated':
          notificationMsg = `${invokerName} `+ this.translate.instant("has updated Kellerbook") +`: ${payload.cellar_bk_nm}`;
          break;
        case 'Wine added':
          notificationMsg = `${invokerName} `+ this.translate.instant("has added new Wine") +`: ${payload.wine_name}`;
          break;
        case 'Wine updated':
          notificationMsg = `${invokerName} `+this.translate.instant("has updated Wine") +`: ${payload.wine_name}`;
          break;
        case 'Wine deleted':
          notificationMsg = this.translate.instant("notifications.wine_deleted").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.wine_name);
          break;
        case 'New Friend Request':
          notificationMsg = this.translate.instant("You have a new Friend Request from") +` ${invokerName}`;
          this.updateFriendList();
          break;
        case 'Friend Request Accepted':
          notificationMsg = `${invokerName} `+ this.translate.instant("has accepted your Friend Request");
          this.updateFriendList();
          break;
        case 'Invitation to the community':
          notificationMsg = this.translate.instant("notifications.invitation_to_the_community").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.community_name);
          break;
        case 'Invitation to the community accepted':
          notificationMsg = this.translate.instant("notifications.invitation_to_the_community_accepted").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.community_name); 
          break; 
        case 'User join community by search':
          notificationMsg = this.translate.instant("notifications.user_join_community_by_search").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.community_name); 
          break;    
        case 'New Post':
            notificationMsg = this.translate.instant("notifications.new_post").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.community_name);
          break;
        case 'Post Reaction':
          notificationMsg = `${invokerName} `+ this.translate.instant("has liked your post");
          break;
        case 'New Comment':
          notificationMsg = `${invokerName} `+ this.translate.instant("has commented on your post");
          break;
        case 'Comment Reaction':
          notificationMsg = `${invokerName} `+ this.translate.instant("has liked your comment");
          break;
        case 'Sale Added':
          notificationMsg = this.translate.instant("notifications.sale_added").replace(/\$1|\$2|\$3/g, match => match === "$1" ? invokerName : match === "$2" ? payload.wine_name : payload.sell_price);
          break;
        case 'New Bid Added':
          notificationMsg = this.translate.instant("notifications.new_bid_added").replace("$1", payload.wine_name);
          break;
        case 'Bid Rejected By Seller':
          notificationMsg = this.translate.instant("notifications.bid_rejected_by_seller").replace("$1", payload.wine_name);
          break;
        case 'Bid Accepted':
          notificationMsg = this.translate.instant("notifications.bid_accepted").replace("$1", payload.wine_name);
          notificationsPopUp.push({wineName: payload.wine_name, category: 'Bid Accepted'});
          this.markAsReadAndRemove({id: response.event_id});
          break;
        case 'Bid Deleted By Bidder':
          notificationMsg = this.translate.instant("notifications.bid_deleted_by_bidder").replace("$1", payload.wine_name);
          break;  
        case 'Sale Settele By Buyer':
          notificationMsg = this.translate.instant("notifications.sale_settele_by_buyer").replace("$1", payload.wine_name); 
          break; 
        case 'Sale Settele For Seller':
          notificationMsg = this.translate.instant("notifications.sale_settele_by_buyer").replace("$1", payload.wine_name);
          notificationsPopUp.push({wineName: payload.wine_name, category: 'Sale Settele For Seller'});
          this.markAsReadAndRemove({id: response.event_id});
          break;
        case 'Sale bid view expired':
          notificationMsg = this.translate.instant("notifications.sale_bid_view_expired").replace("$1", payload.wine_name);
          break;
        case 'Level Upgrade':
          notificationMsg = this.translate.instant("notifications.level_upgrade").replace("$1", payload.new_level);
          const data = {
            userLevel: parseInt(payload.new_level ?? 1)
          };
          levelNotifications.push(data);
          if (Number(payload.vino_coins) > 0) {
            const data = {
              earnVcCount: payload.vino_coins,
              earnVcDescription:  this.translate.instant("notifications.reach_level").replace("$1", this.translate.instant("levels." + payload.description.toLowerCase()))
            }
            vcEarnNotifications.push(data);
          }
          this.markAsReadAndRemove({id: response.event_id});
          break;
        case 'Got 3 vino Coins for friend referal':
          notificationMsg = this.translate.instant("notifications.got_3_vino_coins_for_friend_referal");
          const data1 = {
            earnVcCount: '3',
            earnVcDescription: this.translate.instant("notifications.referred_friend")
          }
          vcEarnNotifications.push(data1);
          this.markAsReadAndRemove({id: response.event_id});
          break;   
        case 'Pincode Is Not Match':
          notificationMsg = this.translate.instant("notifications.pincode_is_not_match");
          break;      
        default:
          notificationMsg = this.translate.instant("You have a new Notification from") +` ${invokerName}`;
          break;
      }
      this.userProfileDataService.setVinoCoins();
      if (levelNotifications.length) {
        this.userDataService.setUserLevelUp(levelNotifications);
      }
      if (vcEarnNotifications.length) {
        this.userDataService.showUserVcEarnInfo(vcEarnNotifications);
      }
      if (notificationsPopUp.length) {
        this.userDataService.showNotificationsPopup(notificationsPopUp);
      }
      if (response.category !== 'Level Upgrade' || response.category !== 'Got 3 vino Coins for friend referal') {
        let durationInSecond = this.getNotificationDuration(response.created_timestamp); 

        this.notifications.push(
          new Notification(
            notificationMsg,
            response.event_id,
            response.category,
            payload?.cellar_bk_id,
            payload?.user_wine_id,
            response.invoker_user_id,
            response.created_timestamp,
            payload?.community_id,
            (response?.invoker_userType == "Business User") ? response?.invoker_companyName : response?.invoker_firstname,
            payload?.sales_id,
            payload?.bid_detail_id,
            durationInSecond
          ),
        );
      }
    }
  }

  processOfflineNotifications(response): void {
    const offlineNotifications = response;
    let notificationsNew:Notification[] = []
    let levelNotifications = [];
    let vcEarnNotifications = [];
    let notificationsPopUp = [];
    this.currentTime = new Date().getTime();
    for (const notification of offlineNotifications) {
      let notificationMsg = '';
      const payload = notification.payload;
      let invokerName = `${notification.invoker_user_info.firstname ? notification.invoker_user_info.firstname : ""} ${notification.invoker_user_info.lastname ? notification.invoker_user_info.lastname : "" }`;
      if (notification.invoker_user_info.userType == "Business User") {
        invokerName = `${notification.invoker_user_info.companyName}`;
      }
      switch (notification.category) {
        case 'Kellerbook created':
          notificationMsg = `${invokerName} `+ this.translate.instant("has added new Kellerbook") +`: ${payload.cellar_bk_nm}`;
          break;
        case 'Kellerbook updated':
          notificationMsg = `${invokerName} `+ this.translate.instant("has updated Kellerbook") +`: ${payload.cellar_bk_nm}`;
          break;
        case 'Wine added':
          notificationMsg = `${invokerName} `+ this.translate.instant("has added new Wine") +`: ${payload.wine_name}`;
          break;
        case 'Wine updated':
          notificationMsg = `${invokerName} `+ this.translate.instant("has updated Wine") +`: ${payload.wine_name}`;
          break;
        case 'Wine deleted':
          notificationMsg = this.translate.instant("notifications.wine_deleted").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.wine_name);
          break;  
        case 'New Friend Request':
          notificationMsg = this.translate.instant("You have a new Friend Request from") +` ${invokerName}`;
          break;
        case 'Friend Request Accepted':
          notificationMsg = `${invokerName} `+ this.translate.instant("has accepted your Friend Request");
          break;
        case 'Invitation to the community':
          notificationMsg = this.translate.instant("notifications.invitation_to_the_community").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.community_name);
          break;
        case 'Invitation to the community accepted':
          notificationMsg = this.translate.instant("notifications.invitation_to_the_community_accepted").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.community_name); 
          break; 
        case 'User join community by search':
          notificationMsg = this.translate.instant("notifications.user_join_community_by_search").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.community_name); 
          break;    
        case 'New Post':
            notificationMsg = this.translate.instant("notifications.new_post").replace(/\$1|\$2/g, match => match === "$1" ? invokerName : payload.community_name);
          break;
        case 'Post Reaction':
          notificationMsg = `${invokerName} `+this.translate.instant("has liked your post");
          break;
        case 'New Comment':
          notificationMsg = `${invokerName} `+this.translate.instant("has commented on your post");
          break;
        case 'Comment Reaction':
          notificationMsg = `${invokerName} `+this.translate.instant("has liked your comment");
          break;
        case 'Sale Added':
          notificationMsg = this.translate.instant("notifications.sale_added").replace(/\$1|\$2|\$3/g, match => match === "$1" ? invokerName : match === "$2" ? payload.wine_name : payload.sell_price);
          break;
        case 'New Bid Added':
          notificationMsg = this.translate.instant("notifications.new_bid_added").replace("$1", payload.wine_name);
          break;
        case 'Bid Rejected By Seller':
          notificationMsg = this.translate.instant("notifications.bid_rejected_by_seller").replace("$1", payload.wine_name);
          break;
        case 'Bid Accepted':
          notificationMsg = this.translate.instant("notifications.bid_accepted").replace("$1", payload.wine_name);
          notificationsPopUp.push({wineName: payload.wine_name, category: 'Bid Accepted'});
          this.markAsReadAndRemove({id: notification.event_id});
          break;
        case 'Bid Deleted By Bidder':
          notificationMsg = this.translate.instant("notifications.bid_deleted_by_bidder").replace("$1", payload.wine_name);
          break;  
        case 'Sale Settele By Buyer':
          notificationMsg = this.translate.instant("notifications.sale_settele_by_buyer").replace("$1", payload.wine_name); 
          break; 
        case 'Sale Settele For Seller':
          notificationMsg = this.translate.instant("notifications.sale_settele_by_buyer").replace("$1", payload.wine_name);
          notificationsPopUp.push({wineName: payload.wine_name, category: 'Sale Settele For Seller'});
          this.markAsReadAndRemove({id: notification.event_id});
          break;
        case 'Sale bid view expired':
          notificationMsg = this.translate.instant("notifications.sale_bid_view_expired").replace("$1", payload.wine_name);
          break;
        case 'Level Upgrade':
          notificationMsg = this.translate.instant("notifications.level_upgrade").replace("$1", payload.new_level);
          const data = {
            userLevel: parseInt(payload.new_level ?? 1)
          };
          levelNotifications.push(data);
          if (Number(payload.vino_coins) > 0) {
            const data = {
              earnVcCount: payload.vino_coins,
              earnVcDescription:  this.translate.instant("notifications.reach_level").replace("$1", this.translate.instant("levels." + payload.description.toLowerCase()))
            }
            vcEarnNotifications.push(data);
          }
          this.markAsReadAndRemove({id: notification.event_id});
          break;
        case 'Got 3 vino Coins for friend referal':
          notificationMsg = this.translate.instant("notifications.got_3_vino_coins_for_friend_referal");
          const data1 = {
            earnVcCount: '3',
            earnVcDescription: this.translate.instant("notifications.referred_friend")
          }
          vcEarnNotifications.push(data1);
          this.markAsReadAndRemove({id: notification.event_id});
          break;   
        case 'Pincode Is Not Match':
          notificationMsg = this.translate.instant("notifications.pincode_is_not_match");
          break; 
        default:
          notificationMsg = this.translate.instant("You have a new Notification from") +` ${invokerName}`;
          break;
      }
      this.userProfileDataService.setVinoCoins();
      if (notification.category !== 'Level Upgrade' || notification.category !== 'Got 3 vino Coins for friend referal') {
        let durationInSecond = this.getNotificationDuration(notification.created_timestamp);  
        notificationsNew.push(
          new Notification(
            notificationMsg,
            notification.event_id,
            notification.category,
            notification.payload?.cellar_bk_id,
            notification.payload?.user_wine_id,
            notification.invoker_user_id,
            notification.created_timestamp,
            notification.payload?.community_id,
            (notification?.invoker_user_info.userType == "Business User") ? notification?.invoker_user_info.companyName : notification.invoker_user_info.firstname,
            notification.payload?.sales_id,
            notification.payload?.bid_detail_id,
            durationInSecond
          ),
        );  
      }
    }
    this.notifications = notificationsNew;
    if (levelNotifications.length) {
      this.userDataService.setUserLevelUp(levelNotifications);
    }
    if (vcEarnNotifications.length) {
      this.userDataService.showUserVcEarnInfo(vcEarnNotifications);
    }
    if (notificationsPopUp.length) {
      this.userDataService.showNotificationsPopup(notificationsPopUp);
    }
  }
  
  getNotificationDuration(created_timestamp: any) {
    const notificationDate = new Date(created_timestamp + ' UTC').getTime();
    const seconds = (this.currentTime - notificationDate) / 1000;
    return seconds;
  }

  handleNotification(notification, index): void {
    this.notificationService.setNotificationAsRead(notification.id).subscribe(({data}) => {
    },(error) => {
      console.log('there was an error sending the query', error);
    });
    // this.storageService.setLocalStorage('friendName', notification?.userName);
    localStorage.setItem("friendName", JSON.stringify(notification?.userName));
    let routePath = 'dashboard';
    let fragment = null;
    let isQuery = null;
    switch (notification.category) {
      case 'Kellerbook created':
      case 'Kellerbook updated':
      case 'Wine deleted':  
        // this.storageService.setLocalStorage('friendName', data.firstname);
        // this.storageService.setLocalStorage('friendPictureId', data.picture);
        // this.storageService.setLocalStorage('friendIdentityId', data.identityId);
        routePath = `/friends/${notification.invoker_user_id}/cellarbook/${notification.cellar_bk_id}`;
        break;
      case 'Wine added':
      case 'Wine updated':
        // this.storageService.setLocalStorage('friendName', data.firstname);
        // this.storageService.setLocalStorage('friendPictureId', data.picture);
        // this.storageService.setLocalStorage('friendIdentityId', data.identityId);
        routePath = `/friends/${notification.invoker_user_id}/cellarbook/${notification.cellar_bk_id}/view-wine/${notification.user_wine_id}`;
        break;
      case 'New Friend Request':
        routePath = 'friends';
        fragment = 'friendRequests';
        break;
      case 'Friend Request Accepted':
        routePath = 'friends';
        fragment = 'friendList';
        break;
      case 'Invitation to the community':
        routePath = 'communities/list';
        fragment = 'pendingRequests';
        break;
      case 'New Post':
      case 'Post Reaction':
      case 'New Comment':
      case 'Comment Reaction':
      case 'Invitation to the community accepted':
      case  'User join community by search':  
        routePath = `communities/${notification.community_id}`;
        break;    
      case 'Sale Added':
        routePath = 'marketplace';
        fragment = 'offers';
        isQuery = {"saleid": notification?.sales_id};   
        break;       
      case 'Sale Settele':
        break;
      case 'Bid Deleted By Bidder':
      case 'Bid Rejected By Seller':
      case 'New Bid Added':  
        routePath = 'marketplace';
        fragment = 'mySales';
        isQuery = {"saleid": notification?.sales_id};
        break;   
      case 'Bid Accepted':  
        routePath = 'marketplace';
        fragment = 'myBids';
        isQuery = {"bidid": notification?.bid_detail_id, "saleid": notification?.sales_id};
        break;  
      case 'Sale Settele By Buyer':   
        routePath = 'marketplace';
        fragment = 'myBids'; 
        isQuery = {"bidid": notification?.bid_detail_id, "saleid": notification?.sales_id};
        break;
      case 'Sale Settele For Seller':  
        routePath = 'marketplace';
        fragment = 'mySales';  
        isQuery = {"saleid": notification?.sales_id};      
        break;     
      case 'Sale bid view expired':  
        routePath = 'marketplace';
        fragment = 'mySales';  
        isQuery = {"saleid": notification?.sales_id};      
        break;
      case 'Got 3 vino Coins for friend referal':  
        routePath = 'profile';
        fragment = 'payment';
        break;
      default:
        break;
    }
    if (fragment !== null && isQuery !== null) {
      this.router.navigate([routePath], { fragment: fragment, queryParams: isQuery });
    }
    else if (fragment !== null) {
      this.router.navigate([routePath], { fragment });
    } else {
      this.router.navigate([routePath]);
    }
    this.removeNotification(index);
  }

  markAsReadAndRemove(notification: any, index?: number): void {
    this.notificationService.setNotificationAsRead(notification.id).subscribe(({data}) => {
      if (index >= 0) {
        this.removeNotification(index);
      }
    },(error) => {
      console.log('there was an error sending the query', error);
    });
  }

  removeNotification(index): void {
    this.notifications.splice(index, 1);
  }

  clearAllNotifications(): void {
    this.notifications.forEach((item) => {
      this.notificationService.setNotificationAsRead(item.id).subscribe();
    })
    this.notifications.splice(0, this.notifications.length)
  }

  showHideNotifications(): void {
    this.showNotifications = !this.showNotifications;
  }

  onClickOutNotifications(): void {
    this.showNotifications = false;
  }

  ngOnDestroy(): void {
    this.notificationSub.unsubscribe();
  }

  updateFriendList() {
    const currentPath = this.router.url;
    if (currentPath.includes('friends')) {
      this.friendsService.updateFriendList$.next("");
    }
  }
}
